import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'
import * as actionCreators from 'store/actions';
import * as api from 'api'

import { Modal, Spinner } from 'components'
import { DeleteDialogue } from 'features'

const styles = {
    boxShadow: 'var(--box-shadow)',
    padding: '1rem',
    border: '1px solid var(--primary-accent2-color)'
}

const PaymentMethodInput = props => {
    const {

    } = props;
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const [showSpinner, setSpinner] = React.useState(false)

    // Handlers
    const onClose = () => {
        dispatch(actionCreators.setModal(null,null))
    }
    const getUrl = () => {
        setSpinner(true)
        api.collectPaymentMethod({userId: user['uid']})
        .then(res => {
            const url = res.data['url']
            window.open(url, '_self')
            setSpinner(false)
        })
        .catch(err => {

        })
    }
    
    return (
        <Modal>
            <DeleteDialogue closeHandler={onClose} onDelete={getUrl}
                submitText={showSpinner ? <Spinner styles={{color: 'var(--text-color)'}}/> : 'Confirm' }
                warningText='Change payment method?' subtitle='You will be redirected to our partner site'
                styles={styles}/>
        </Modal>
    )
}

export default PaymentMethodInput;